import type { RequestType } from '@libs/templates/mst';
import { MstRegistrationTmpl } from '@libs/templates/mst';
import type { Characters, Item, ItemName, PageProps } from '@ps-smart-cp/ppfw-client';
import { withRerender } from '@ps-smart-cp/ppfw-client';
import { AdditionalInfo } from './components';
import { locationMstRegistrationFieldConfig } from './item-config';
import { LocationMstRegistration } from './models';
import { fetchMst, register, update } from './repositories';

function PageComponent({
  type,
  item,
  itemName,
  ...restProps
}: PageProps & Pick<RequestType, 'type'> & { item: Item<Characters> } & { itemName: ItemName }) {
  const requestType =
    type === 'new'
      ? { type, registrationFunction: register }
      : { type, updateFunction: update, fetchFunction: fetchMst };

  return (
    <MstRegistrationTmpl
      mstName={itemName}
      initMst={LocationMstRegistration.init}
      items={{ ...locationMstRegistrationFieldConfig, code: item }}
      {...requestType}
      {...restProps}
    >
      {AdditionalInfo}
    </MstRegistrationTmpl>
  );
}

const Registration = withRerender(PageComponent, 'Registration');

export { Registration };
